export let commaSeperatedEmailPattern = /^([\w+-.%']+@[\w-.]+\.[A-Za-z]{2,}(\s*,?\s*)*)+$/;
export let emailPattern = /^[a-zA-Z0-9._%'+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// necessary for places where email pattern is used in a text input validator
// be sure to duplicate from common email pattern to keep in sync
export let inputEmailPattern = String.raw`[a-zA-Z0-9._%'+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}`;
export let uuidPattern =
  /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;
